import { fetchTicketbyTokenAction } from '../components/Tickets/actions/ticketsActions';
import WIDGETS from './widgets';

export default {
	name: 'ticket_chat',
	spacing: 0,
	sx: {
		height: '100%',
	},
	// onmount: (dispatch) => {
	//   console.log('aqui?!');
	//   dispatch(fetchTicketbyTokenAction('116NGHA9CCP5J', false));
	// },
	widgets: [
		// { content: WIDGETS.HEADER, breakpoints: { xs: 12 }, lazy_loading: 0 },
		{
			content: WIDGETS.LAYOUT_CHAT,
			breakpoints: { xs: 12 },
			lazy_loading: 0,
			component_props: {
        // redux: { channel_name: 'tickets.ticket.channel.name' },
				stack_divider: true,
				stack_props: { sx: { height: '100%' } },
			},
			sx: {
				height: '100%',
			},
		},
	],
};
